import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React, { FC } from 'react';

import { defineStyles } from '../../theme';

const styles = defineStyles({
  loadingContainer: {
    zIndex: 100,
    color: (theme) => theme.palette.secondary.main,
  },
});

export type LoadingBackdropProps = {
  isLoading: boolean;
};

const LoadingBackdrop: FC<LoadingBackdropProps> = ({ isLoading }) => (
  <Backdrop sx={styles.loadingContainer} open={isLoading}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default LoadingBackdrop;
